<template>
  <div>
    <!-- 仪表（房产） 流程-->
      <div style="height: 98vh;overflow-y: auto;">
        <div style="margin: 10px;">
          <el-button @click="selects(1)">查询</el-button>
          <el-button v-if="flow.status == 2" @click="orders(2)">生成账单</el-button>
          <el-button @click="excel">导出</el-button>
          <!-- <el-button v-if="flow.status == 2" @click="orders(2)">重新生成账单</el-button> -->
          <div>
            <el-descriptions :column="2" border size="mini" style="margin-top: 10px;" :labelStyle="{width: '123px'}" :contentStyle="{width:'42%'}">
              <el-descriptions-item label="仪表编号">
                <el-input size="mini" v-model="select.xsc_bill_no" clearable placeholder="仪表编号"></el-input>
              </el-descriptions-item>
              <el-descriptions-item label="房产信息">
                <el-select v-model="select.house" size="mini" placeholder="可搜索房产" filterable remote clearable reserve-keyword :remote-method="remoteMethod" style="width: 100%;">
                  <el-option v-for="item in house" :key="item.id" :label="item.house" :value="item.house"></el-option>
                </el-select>
              </el-descriptions-item>
              <el-descriptions-item  label="计费周期">
                <el-date-picker v-model="select.date_s" type="date" size="mini" style="width: 47%;" placeholder="开始日期"></el-date-picker>
                <span style="margin-left: 1px;margin-right: 1px;">至</span>
                <el-date-picker v-model="select.date_e" type="date" size="mini" style="width: 47%;" placeholder="结束日期"></el-date-picker>
              </el-descriptions-item>

              <el-descriptions-item label="流程编号">
                {{flow.process_name}}
              </el-descriptions-item>

              <el-descriptions-item label="审核状态">
                <el-radio v-model="select.IsCheck" label="1">未审核</el-radio>
                <el-radio v-model="select.IsCheck" label="2">已审核</el-radio>
              </el-descriptions-item>
              <el-descriptions-item label="">

              </el-descriptions-item>

            </el-descriptions>
          </div>
          <div style="margin-top: 10px;">
            <span style="margin-left: 5px;">总金费：<span style="color: red;">{{money}}</span>元</span>
            <span style="margin-left: 15px;color: red;" v-if="loading_dade==2">加载中...</span>
            <el-table ref="multipleTable" :data="tableData" border tooltip-effect="dark" style="width: 100%" height="60vh" >
              <el-table-column prop="meter_number" label="仪表编号" width="150"></el-table-column>
              <el-table-column prop="h_name_date" label="房产"></el-table-column>
              <el-table-column prop="customer_name" label="缴费对象" width="200"></el-table-column>
              <el-table-column prop="charge_item_namd" label="收费项目" width="150"></el-table-column>
              <el-table-column label="计费周期" width="180">
                <template slot-scope="scope">
                  {{scope.row.startDate}}-{{scope.row.endDate}}
                </template>
              </el-table-column>
              <el-table-column prop="xsc_LastReadDegree" label="上期读数" width="120"></el-table-column>
              <el-table-column prop="xsc_CurrentReadDegree" label="本期读数" width="120"></el-table-column>
              <el-table-column prop="xsc_Amount" label="数量" width="120"></el-table-column>
              <el-table-column prop="xsc_Price" label="单价" width="120"></el-table-column>
              <el-table-column prop="charge" label="金额" width="120"></el-table-column>
            </el-table>
          </div>
          <div class="pages" style="margin-top: 30px;margin-left: 20px;">
            <Page :total="total" :page-size="page" @on-change="selects" show-total />
          </div>
        </div>

      </div>
  </div>
</template>

<script>
export default {
  // 接受父组件的值
  props: {
    batch_number2:{
      type:String|Number,
      default(){
        return''
      }
    },
    task_id2:{
      type:String|Number,
      default(){
        return''
      }
    },
    master_id2:{
      type:String|Number,
      default(){
        return''
      }
    },
    meter_temp_money:{
      type:String|Number,
      default(){
        return 0
      }
    },
  },
  watch:{

  },
  data () {
    return {
      loading_dade:1,
      dialogVisible:false,
      tableData: [],
      order: [],
      money_val:0,
      money:0,
      total:0,
      page:12,
      select:{
        batch_number:'',
        task_id:'',
        pindex_id:'',
        IsCheck:'1',
        date_s:'',
        date_e:'',
        house:'',
        xsc_bill_no:'',
        nomber:''
      },
      house:[],
      flow:'',
      loading:false
    }
  },

  mounted(){
    this.select.batch_number = this.$route.query.batch_number||this.batch_number2;
    this.select.task_id = this.$route.query.task_id||this.task_id2;
    this.selects(1);
  },
  //事件
  methods: {
    selects(e){
      this.loading_dade = 2;
      let data = {'select':this.select,'page':e}
      this.$myhttp.post('admin/MeterFlow/meter_list',data,{
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(backdata=>{ // 异步执行成功后
        this.loading_dade = 1;
        if(backdata.data.code == 200){
           this.tableData = backdata.data.data;
           this.money = backdata.data.money;
           this.total = backdata.data.count;
           this.flow = backdata.data.flow;
        }else{
          this.$Message.error(backdata.data.message);
        }
      },err=>{
        this.loading_dade = 1;
        this.$Message.error('请求异常!');
      });
    },
    //导出
    excel(){
      this.loading_dade = 2;
      let data = {'select':this.select,'page':1}
      this.$myhttp.post('admin/MeterFlow/meter_excel',data,{
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(backdata=>{ // 异步执行成功后
        this.loading_dade = 1;
        if(backdata.data.code == 200){
          let url = this.$myhttp.defaults.baseURL;
          window.open(url+backdata.data.data, '_blank');
        }else{
          this.$Message.error(backdata.data.message);
        }
      },err=>{
        this.loading_dade = 1;
        this.$Message.error('请求异常!');
      });
    },
    //生成账单
    orders(type){
      this.$confirm('确定要操作吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading_dade = 1;
        ERP.showLoading()
        this.select.type = type;
        this.$myhttp.post('admin/MeterFlow/order_meter',this.select,{
          'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
          this.selects(1);
          ERP.hideLoading()
          //if(backdata.data.code==200){
            //console.log(backdata.data.message)
            //this.$Message.success(backdata.data.message);
          // }else{
          //   this.$Message.error(backdata.data.message);
          // }
          this.$confirm(backdata.data.message, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {

          },err=>{

          })
        },err=>{
          ERP.hideLoading()
          this.$Message.error('请求异常!');
        });
      })
    },
    order_1(){

    },
    //远程搜索
    remoteMethod(query){
      if (query !== '') {
        this.$myhttp.get('admin/common/house_name1?house_name='+encodeURIComponent(query),{
          'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
          this.house = backdata.data.data;
        });
      }
    },
  },
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Admin/Meter/order/MeterList.vue